import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Stack
} from "@mui/material";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { ITopPurchaser } from '../../store/interfaces/ITopPurchaser';
import { useIsMobileView } from '../../utils/responsive';
import { useGetTopPurchasersQuery } from '../../store/api';

interface TopPurchasersProps {
  raffleId: string;
}

const TopPurchasers: React.FC<TopPurchasersProps> = ({ raffleId }) => {
    const { data: topPurchasersFounded } = useGetTopPurchasersQuery(raffleId, {
      skip: raffleId === 'default',
      refetchOnReconnect: true,
      refetchOnFocus: true,
      refetchOnMountOrArgChange: true,
    });
  

  const renderTrophyIcon = (index: number) => {
    if (index === 0) return <EmojiEventsIcon sx={{ fontSize: 18, color: 'gold' }} />;
    if (index === 1) return <EmojiEventsIcon sx={{ fontSize: 18, color: 'silver' }} />;
    if (index === 2) return <EmojiEventsIcon sx={{ fontSize: 18, color: 'peru' }} />;
    return null;
  };

  const orderedTopPurchasers = [...(topPurchasersFounded ?? [])].sort((a, b) => b.ticketCount - a.ticketCount);
  const isMobile = useIsMobileView();

    if (topPurchasersFounded == null) {
    return (<></>);
  }


  return (
    <Box mt={1}>
      {isMobile ? (
        <Box>
          {orderedTopPurchasers.map((purchaser, index) => (
            <Card key={purchaser.email} sx={{ mb: 1 }}>
              <CardContent sx={{ py: 1.5, px: 2 }}>
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                  {renderTrophyIcon(index)}
                  <Typography fontSize={14} fontWeight="bold">{purchaser.ticketCount}</Typography>
                  <Typography fontSize={14}>{purchaser.name}</Typography>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Box>
      ) : (
        <Table size="small">
          <TableBody>
            {orderedTopPurchasers.map((purchaser, index) => (
              <TableRow key={purchaser.email} sx={{ height: 36 }}>
                <TableCell>{renderTrophyIcon(index)}</TableCell>
                <TableCell>
                  <Typography fontSize={14}>{purchaser.name}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontSize={14} fontWeight="bold">{purchaser.ticketCount}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      {orderedTopPurchasers.length === 0 && (
        <Box width="100%" mt={2}>
          <Typography textAlign="center" fontSize={14} color="text.secondary">
            No hay compradores.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default TopPurchasers;
